export default __webpack_public_path__ + "./font/20c75e982fb7fc298564dc3562139f89.woff";